module.exports = __webpack_public_path__ + "media/game_bg.3f0e1f4d.mp3";